export default __webpack_public_path__ + "static/media/ic_ivory_coast.720c1b31.svg";